import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchGetQuery, fetchPutQuery } from "../api";

// API call to get project details for Splosno section
export function useGetProjectSplosnoDetails(id) {
  const url = `Projekti/${id}/splosnoV2`;
  return useQuery({
    queryKey: ["project-splosno-details", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//API call to get sifrant projektov on search
export function useGetSifrantProjektov(searchTerm) {
  const url = `Projekti/sifrantV2?search=${searchTerm}`;
  return useQuery({
    queryKey: ["sifrant-projektov", searchTerm],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    enabled: !!searchTerm && searchTerm.length >= 3, // Only run this query if searchTerm is not empty
  });
}

//API call to get sifranti razpisov on search
export function useGetSifrantRazpisov(searchTerm) {
  const url = `Razpisi/sifrantV2?search=${searchTerm}`;
  return useQuery({
    queryKey: ["sifrant-razpisov", searchTerm],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    enabled: !!searchTerm && searchTerm.length >= 3, // Only run this query if searchTerm is not empty
  });
}

//API call to get sifrant arrs cerif klasius
export function useGetSifrantArrsCerifKlasius() {
  const url = `Sifrant/arrs_cerif_klasius_V2`;
  return useQuery({
    queryKey: ["sifrant-arrs-cerif-klasius"],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//API call to get which sifrant arrs cerif klasius is selected for a razpis on project details
export function useGetPodrocjaSifrantForRazpis(razpisID) {
  const url = `Razpisi/${razpisID}/sifrantiV2`;
  return useQuery({
    queryKey: ["sifrant-podrocja", razpisID],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    enabled: !!razpisID, // Only run this query if razpisID is not null or undefined
  });
}

//API for put to update project details splosno section
export function useEditProjectSplosnoDetails(payload) {
  const url = `Projekti/splosnoV2`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      return fetchPutQuery(url, payload);
    },
    onSuccess: () => {
      // Invalidate and refetch project splosno details after successful update
      queryClient.invalidateQueries({
        queryKey: ["project-splosno-details"],
      });
      queryClient.invalidateQueries({
        queryKey: ["project-status-naziv"],
      });
    },
  });
}
